








































import { Vue, Component, Prop } from "vue-property-decorator";

interface StatusOptions {
  type: string;
  alignment: number;
  status: number;
  tooltip?: string;
  title?: string;
}

@Component({})
export default class StatusCard extends Vue {
  @Prop() options!: StatusOptions;

  //  @Getters

  get indicatorTitle(): string {
    return this.options.title || "";
  }

  get indicatorText(): string {
    return this.options.alignment.toString();
  }

  get indicatorIcon(): string {
    const status = this.options.status;
    if (status == 2) {
      return "mdi-check-circle";
    } else if (status == 1) {
      return "mdi-alert-circle";
    } else {
      return "mdi-minus-circle";
    }
  }

  get statusColor(): string {
    if (!this.options || typeof this.options.status !== "number") return "ContentTertiary";

    const status = this.options.status;

    if (status == 2) {
      return "ContentPositivePrimary";
    } else if (status == 1) {
      return "ContentWarningSecondary";
    } else {
      return "ContentNegativePrimary";
    }
  }

  get formattedToolTip(): string {
    return this.options.tooltip?.replace(/\n/g, "<br />") || "";
  }
}
